export const SET_TOKEN = "SET_TOKEN";

export interface SetToken {
  type: typeof SET_TOKEN;
  token: string | any;
}

export type UserToken = SetToken;
